import { removeDesignPro } from "../../store/actions/userActions";
import {
  handleSaveProjects,
  removeBonding,
  removeFeeSimple,
  removeMortgage,
  removeSavedProject,
} from "../../store/actions/dataActions";
import { setBuildingState } from "../../store/actions/permitFormActions/buildingStateActions";
import { setBuildingPermitModals } from "../../store/actions/permitFormActions/modalControlStateActions";

//! HANDLE REMOVE PROJECTS AND DESIGN PRO /////////////////////////////////////////////
export const handleDesignProRemove = async (
  formikValues,
  formikSetValues,
  dispatch
) => {
  // Dispatch the action to remove the design professional from the Redux store
  await dispatch(removeDesignPro(formikValues.designProfessional));
  formikSetValues({
    ...formikValues,
    designProfessional: "",
    design_pro_company: "",
    design_pro_license_name: "",
    design_pro_license_num: "",
    design_pro_address: "",
    design_pro_phone: "",
    design_pro_fax: "",
    design_pro_email: "",
    // reset other fields here if needed
  });
  await dispatch(setBuildingPermitModals({ addDesignProConfirmOpen: false }));

  dispatch(
    setBuildingState({ addingNewDesignPro: false, submitDisabled: false })
  );
};

export const handleProjectRemove = async (
  formikValues,
  formikSetValues,
  dispatch
) => {
  // Dispatch the action to remove the design professional from the Redux store

  await dispatch(removeSavedProject(formikValues.projectContact));
  formikSetValues({
    ...formikValues,
    projectContact: "",
    project_contact: "",
    project_c_phone: "",
  });
  await dispatch(setBuildingPermitModals({ projectConfirmModalOpen: false }));
  dispatch(handleSaveProjects());

  dispatch(
    setBuildingState({ addingNewProject: false, projectSubmitDisabled: false })
  );
};

export const handleFeeSimpleRemove = async (
  formikValues,
  formikSetValues,
  dispatch
) => {
  // Dispatch the action to remove the design professional from the Redux store
  await dispatch(removeFeeSimple(formikValues.feeSimpleTitleholder));
  formikSetValues({
    ...formikValues,
    feeSimpleTitleholder: "",
    fee_simple_name: "",
    fee_simple_address: "",
  });

  dispatch(setBuildingPermitModals({ feeSimpleConfirmModalOpen: false }));
  dispatch(handleSaveProjects());

  dispatch(
    setBuildingState({
      addingNewFeeSimple: false,
      feeSimpleSubmitDisabled: false,
    })
  );
};

export const handleBondingRemove = async (
  formikValues,
  formikSetValues,
  dispatch
) => {
  // Dispatch the action to remove the design professional from the Redux store
  await dispatch(removeBonding(formikValues.bondingCompany));
  formikSetValues({
    ...formikValues,
    bondingCompany: "",
    bonding_name: "",
    bonding_address: "",
  });
  dispatch(setBuildingPermitModals({ bondingConfirmModalOpen: false }));
  dispatch(handleSaveProjects());

  dispatch(
    setBuildingState({
      addingNewBonding: false,
      bondingSubmitDisabled: false,
    })
  );
};

export const handleMortgageRemove = async (
  formikValues,
  formikSetValues,
  dispatch
) => {
  // Dispatch the action to remove the design professional from the Redux store
  await dispatch(removeMortgage(formikValues.mortgageLender));
  formikSetValues({
    ...formikValues,
    mortgageLender: "",
    mortgage_name: "",
    mortgage_address: "",
  });
  dispatch(setBuildingPermitModals({ mortgageConfirmModalOpen: false }));
  dispatch(handleSaveProjects());

  dispatch(
    setBuildingState({
      addingNewMortgage: false,
      mortgageSubmitDisabled: false,
    })
  );
};
